import type { CreateScreeningTestField } from '@/types';
import { icons } from '@amili-v3/amili-v3-design/src/icons/components';
import { KitStatus } from './kit';

export enum DonorCycleStatus {
  PASS = 'PASS',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
}

export enum DonorScreeningStatus {
  PASS = 'PASS',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  NA = 'NA',
}

export enum DonorScreeningType {
  AML1 = 'AML1',
  AML2 = 'AML2',
  AML_STOOL = 'AML_STOOL',
  ZYMO_STOOL = 'ZYMO_STOOL',
  NASAL_SWAB = 'NASAL_SWAB',
}

export enum BottleProductStatus {
  PENDING = 'PENDING',
  SOLD = 'SOLD',
  READY = 'READY',
  PROCESSED = 'PROCESSED',
  CLINIC_RECEIVED = 'CLINIC_RECEIVED',
}

export enum BottleLogAction {
  // to be removed
  BOTTLE_STOCK = 'BOTTLE_STOCK',
  ORDER_PLACEMENT = 'ORDER_PLACEMENT',
  // to be using
  STOCK = 'STOCK', // = READY IN UI
  REMOVE_FROM_ORDER = 'REMOVE_FROM_ORDER', // = READY IN UI
  IN_ORDER = 'IN_ORDER', // = IN PROCESS IN UI
  SOLD = 'SOLD', // = SOLD IN UI
  CLINIC_RECEIVED = 'CLINIC_RECEIVED',
}

export const FMT_STATUS_COLOR: Record<DonorCycleStatus, string[]> = {
  [DonorCycleStatus.PENDING]: ['var(--warning)', 'var(--light-warning)'],
  [DonorCycleStatus.PASS]: ['var(--success)', 'var(--success-hover)'],
  [DonorCycleStatus.FAILED]: ['var(--error)', 'var(--light-error)'],
};

export enum FmtProductStatus {
  DNA_EXTRACTED = 'DNA_EXTRACTED',
  SEQUENCING = 'SEQUENCING',
  SEQUENCED = 'SEQUENCED',
}
export const FMT_PRODUCT_STATUS_COLOR = {
  [FmtProductStatus.DNA_EXTRACTED]: ['var(--secondary)', '#EEEEF3'],
  [FmtProductStatus.SEQUENCING]: ['var(--warning)', '#FFF9EB'],
  [FmtProductStatus.SEQUENCED]: ['var(--success)', 'var(--success-hover)'],
};

export const TEST_RESULT_COLOR = {
  N: 'var(--success)',
  A: 'var(--error)',
};

export const defaultScreeningTests = Object.keys(DonorScreeningType).map(
  key =>
    ({
      testResult: {},
      type: key,
    }) as CreateScreeningTestField,
);

export const screeningTestOrder: Record<DonorScreeningType, number> = {
  [DonorScreeningType.AML1]: 1,
  [DonorScreeningType.NASAL_SWAB]: 2,
  [DonorScreeningType.AML2]: 3,
  [DonorScreeningType.AML_STOOL]: 4,
  [DonorScreeningType.ZYMO_STOOL]: 5,
};

export const FMT_BATCH_ACTION_MAPPER: Record<
  string,
  { iconName: keyof typeof icons; tooltipTitle: string }
> = {
  [KitStatus.KIT_RECEIVED]: {
    iconName: 'extraction',
    tooltipTitle: 'sequencing.sendToExtraction',
  },
  [KitStatus.DNA_EXTRACTED]: {
    iconName: 'sequencing',
    tooltipTitle: 'sequencing.sendForSequencing',
  },
};
